// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M14.5 8C14.5 11.59 11.59 14.5 8 14.5C4.41 14.5 1.5 11.59 1.5 8C1.5 4.41 4.41 1.5 8 1.5C11.59 1.5 14.5 4.41 14.5 8Z',
  'M6.2 5.8C6.2 4.81 7.01 4 8 4C8.99 4 9.8 4.81 9.8 5.8V6.3C9.8 7.29 8.99 8.1 8 8.1C7.01 8.1 6.2 7.29 6.2 6.3V5.8Z',
  'M4 13.12V12.5C4 11.1 5.8 10.3 8 10.3C10.2 10.3 12 11.1 12 12.5V13.12',
];
